import React from 'react'
import './tab.css'

class Tabs extends React.Component {

  static defaultProps = {
    selected: 0,
  }

  state = {
    selected: this.props.selected,
  }

  toggleTab = (id) => {
    this.setState({ selected: id })
    if (this.props.onChange) this.props.onChange(id)
  }

  render() {
    let theme = this.props.primary ? 'primary' : ''
    theme = this.props.secondary ? 'secondary' : theme

    const tabs = React.Children.map(this.props.children, (child, index) => {
      const onSelection = (id) => {
        this.toggleTab(id || index)
      }
      const tab = child.props.id || index
      const selected = tab === this.state.selected
      return React.cloneElement(child, { onSelection, selected })
    })

    return (
      <div className={`tabs ${theme} ${this.props.className}`}>
        {tabs}
      </div>
    )
  }
}

const Tab = (props) => {
  const onSelection = () => {
    props.onSelection(props.id)
  }
  const selected = props.selected ? 'selected' : ''
  const badge = props.info ? <span className="badge">{props.info}</span> : ''
  return (
    <span key={props.id} className={`tab clickable ${selected} ${props.className}`} style={props.style} onMouseUp={onSelection} tabIndex="0">
      {props.children}{props.label}{badge}
    </span>
  )
}

const Stack = (props) => {
  const { className } = props
  const selected = props.selected ? props.selected : 0
  const child = React.Children.toArray(props.children).filter((child, index) => {
    return index === selected
  })[0]
  return (
    <div className={`stack horizontal ${className}`}>
      {child}
    </div>
  )
}


export { Tabs, Tab, Stack }



// WEBPACK FOOTER //
// ./src/lib/components/tab.js